/* =====================================================================
   PONTE AUTOMÁTICA (por tag) — Releasit COD  ->  Checkout Loja B
   ---------------------------------------------------------------------
   NÃO precisa de MAPA manual. O script casa os produtos sozinho pela tag
   rma#/rmb# lendo o products.json das duas lojas. Para abrir uma loja
   nova, ajuste APENAS o bloco CONFIG abaixo.

   Pré-requisitos:
     - Produtos da Loja A taguados com rma1, rma2, ...  (na loja de origem)
     - Produtos da Loja B taguados com rmb1, rmb2, ...  (na loja B)
     - Mesmo número de tag = par equivalente entre as lojas.
   ===================================================================== */
(function () {
  "use strict";

  // ===================== CONFIG (ajustar por loja A) =====================
  const SHOP_A = "";  // deixe "" para usar a própria loja atual; ou ex.: "https://loja-a.myshopify.com"
  const API_B  = "https://xw1pen-0d.myshopify.com/api/2025-07/graphql.json";
  const SHOP_B = "https://xw1pen-0d.myshopify.com"; // domínio da Loja B (para o products.json)
  const STOREFRONT_TOKEN = "02a5d76e49939e54488889ea92ae3db1"; // token PÚBLICO da Loja B

  // Mercado de destino (enums da Shopify)
  const MARKET = { country: "BG", language: "BG" };

  // Campo de nome do Releasit: "single" (1 campo) ou "split" (first_name + last_name)
  const NOME = "split";

  // Upsell + frete (IDs FIXOS da Loja B — não entram no esquema de tags)
  const UPSELL_PERFUME_B = "49155846471932";
  const FRETE_EXPRESSO_B = "49155849486588";

  // DDI por país
  const DDI = { BG: "359", RO: "40", GB: "44", EE: "372", PT: "351", HU: "36", BR: "55", JP: "81", US: "1" };

  const TAG_RE = /^rm[ab](\d+)$/i; // captura o número da tag
  // ======================================================================

  const val = (sel) => document.querySelector(sel)?.value?.trim() || "";

  // ---- Indexa products.json -> { numeroDaTag: variantId } -------------
  async function indexarPorTag(baseUrl) {
    const idx = {};
    for (let page = 1; page <= 20; page++) {
      const url = `${baseUrl || ""}/products.json?limit=250&page=${page}`;
      const r = await fetch(url, { credentials: "omit" }).then((x) => x.json());
      if (!r.products || !r.products.length) break;
      r.products.forEach((p) => {
        const tags = Array.isArray(p.tags) ? p.tags : String(p.tags || "").split(",");
        for (const t of tags) {
          const m = String(t).trim().match(TAG_RE);
          if (m && p.variants && p.variants[0]) { idx[m[1]] = String(p.variants[0].id); break; }
        }
      });
    }
    return idx;
  }

  let mapaPromise = null; // cache: número da tag -> variant ID da B
  async function getMapa() {
    if (!mapaPromise) {
      mapaPromise = (async () => {
        const [idxA, idxB] = await Promise.all([indexarPorTag(SHOP_A), indexarPorTag(SHOP_B)]);
        const mapa = {};            // variantA -> variantB
        for (const num in idxA) {
          if (idxB[num]) mapa[idxA[num]] = idxB[num];
          else console.warn("[ponte] tag sem par na Loja B: rm*" + num);
        }
        console.log("[ponte] mapa montado por tag:", Object.keys(mapa).length, "pares");
        return mapa;
      })();
    }
    return mapaPromise;
  }
  // pré-carrega o mapa assim que a página abre (fica pronto antes do clique)
  getMapa();

  // ---- GraphQL Storefront B ------------------------------------------
  const gql = (query, variables) =>
    fetch(API_B, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": STOREFRONT_TOKEN,
      },
      body: JSON.stringify({ query, variables }),
    }).then((r) => r.json());

  function formatarTelefone(raw, countryCode) {
    let n = (raw || "").replace(/[^\d+]/g, "");
    if (!n) return "";
    if (n.startsWith("+")) return n;
    const ddi = DDI[countryCode] || "";
    n = n.replace(/^0+/, "");
    if (!n) return "";
    return ddi ? `+${ddi}${n}` : "";
  }

  function addLinha(linhas, variantIdB, qty) {
    if (!variantIdB) return;
    const merchandiseId = `gid://shopify/ProductVariant/${variantIdB}`;
    const existente = linhas.find((l) => l.merchandiseId === merchandiseId);
    if (existente) existente.quantity += qty;
    else linhas.push({ merchandiseId, quantity: qty });
  }

  async function lerItens() {
    const mapa = await getMapa();
    const linhas = [];

    document.querySelectorAll('[name^="item_variant_id["]').forEach((el) => {
      const idx = el.name.match(/\[(\d+)\]/)?.[1];
      const qty = parseInt(document.querySelector(`[name="item_quantity[${idx}]"]`)?.value || "1", 10) || 1;
      const vB = mapa[el.value];
      if (vB) addLinha(linhas, vB, qty);
      else console.warn("[ponte] produto A sem par por tag:", el.value);
    });

    const upsellMarcado = [...document.querySelectorAll('[name^="tick_ups_visible_checkbox_"]')]
      .some((chk) => chk.checked);
    if (upsellMarcado) addLinha(linhas, UPSELL_PERFUME_B, 1);

    if (val('[name="shipping_rate_priority"]') === "2") addLinha(linhas, FRETE_EXPRESSO_B, 1);

    return linhas;
  }

  function lerCliente() {
    const countryCode = val('[name="country_code"]') || MARKET.country;
    const phone = formatarTelefone(val('[name="phone"]'), countryCode);

    let firstName, lastName;
    if (NOME === "single") {
      const [p, ...r] = val('[name="first_name"]').split(/\s+/);
      firstName = p || "-";
      lastName = r.join(" ") || "-";
    } else {
      firstName = val('[name="first_name"]') || "-";
      lastName = val('[name="last_name"]') || "-";
    }

    const buyerIdentity = { email: val('[name="email"]'), countryCode };
    if (phone) buyerIdentity.phone = phone;

    const deliveryAddress = {
      firstName, lastName,
      address1: val('[name="address"]'),
      address2: val('[name="civic_number"]'),
      city: val('[name="city"]'),
      zip: val('[name="zip_code"]'),
      countryCode,
    };
    if (phone) deliveryAddress.phone = phone;

    return { buyerIdentity, deliveryAddress };
  }

  async function transferir() {
    try {
      const lines = await lerItens();
      if (!lines.length) { console.error("[ponte] nenhum item mapeado — abortando."); return; }

      const { buyerIdentity, deliveryAddress } = lerCliente();
      console.log("[ponte] itens:", lines, "| cliente:", buyerIdentity, deliveryAddress);

      const c = await gql(
        `mutation($input: CartInput!, $country: CountryCode!, $language: LanguageCode!)
           @inContext(country: $country, language: $language) {
           cartCreate(input: $input) { cart { id checkoutUrl } userErrors { field message } }
         }`,
        { input: { lines, buyerIdentity }, country: MARKET.country, language: MARKET.language }
      );
      const cart = c?.data?.cartCreate?.cart;
      if (!cart) { console.error("[ponte] cartCreate falhou:", c?.data?.cartCreate?.userErrors || c); return; }

      const a = await gql(
        `mutation($id: ID!, $addresses: [CartSelectableAddressInput!]!, $country: CountryCode!, $language: LanguageCode!)
           @inContext(country: $country, language: $language) {
           cartDeliveryAddressesAdd(cartId: $id, addresses: $addresses) { userErrors { field message } }
         }`,
        { id: cart.id, addresses: [{ selected: true, address: { deliveryAddress } }], country: MARKET.country, language: MARKET.language }
      );
      const errs = a?.data?.cartDeliveryAddressesAdd?.userErrors;
      if (errs && errs.length) console.warn("[ponte] aviso no endereço:", errs);

      console.log("[ponte] indo para:", cart.checkoutUrl);
      window.location.href = cart.checkoutUrl;
    } catch (err) {
      console.error("[ponte] erro inesperado:", err);
    }
  }

  document.addEventListener("click", function (e) {
    const btn = e.target.closest("._rsi-buy-now-custom-additionals-button");
    if (!btn) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    transferir();
  }, true);

  console.log("[ponte] script AUTO carregado. mercado:", MARKET, "| nome:", NOME);
})();